import { PilotFeatureProtectedRoute } from '@Component/ProtectedRoute/PilotFeatureProtectedRoute';
import { createBrowserRouter, RouterProvider } from 'react-router';
import { EmployeeOverview } from '@Page/EmployeeOverview/EmployeeOverview';
import { RoutePaths } from '@Util/misc.ts';
import SalaryOnboardingProtectedRoute from '@Component/ProtectedRoute/SalaryOnboardingProtectedRoute.tsx';
import { wrapCreateBrowserRouterV7 } from '@tlx/sentry';
import { SalaryOnboarding } from './Onboarding/SalaryOnboarding';
import { Overview } from './Overview/Overview';
import { PageNotFound } from './PageNotFound/PageNotFound';
import { CreateSalaryRun } from './SalaryRun/CreateSalary';
import { SalaryTaxCard } from './SalaryTaxCard/SalaryTaxCardPage';

const sentryCreateBrowserRouter = wrapCreateBrowserRouterV7(createBrowserRouter);

const router = sentryCreateBrowserRouter(
    [
        {
            path: RoutePaths.CreateSalary,
            element: (
                <PilotFeatureProtectedRoute
                    redirectUrl={CreateSalaryRun.redirectUrl()}
                    hasPageAccess={(pilotFeatures) => pilotFeatures?.CreateSalaryRedesignMVP}
                />
            ),
            children: [
                {
                    element: <SalaryOnboardingProtectedRoute />,
                    children: [{ index: true, element: <CreateSalaryRun /> }],
                },
            ],
        },
        {
            path: RoutePaths.Overview,
            element: <Overview />,
        },
        {
            path: RoutePaths.Taxcard,
            element: <SalaryTaxCard />,
        },
        {
            path: RoutePaths.Onboarding,
            element: <SalaryOnboarding />,
        },
        {
            path: RoutePaths.EmployeeOverview,
            element: (
                <PilotFeatureProtectedRoute
                    redirectUrl={EmployeeOverview.redirectUrl()}
                    hasPageAccess={(pilotFeatures) => pilotFeatures.NewEmployeeOverview}
                />
            ),
            children: [{ index: true, element: <EmployeeOverview /> }],
        },
        {
            path: RoutePaths.NotFound,
            element: <PageNotFound />,
        },
    ],
    { basename: '/page/salary' },
);

export const AppRoutes = () => {
    return <RouterProvider router={router} />;
};
